import { DateInput } from '@mantine/dates';
import { CommonInputProps } from './DataInputField';

type DataInputDateProps = CommonInputProps & {
  valueFormat?: string;
};

export function DataInputDate({
  inputValue,
  setInputValue,
  onSave,
  onKeyDown,
  variant,
  autoFocus,
  ariaLabelledBy,
  valueFormat = 'D MMMM YYYY',
}: DataInputDateProps) {
  return (
    <DateInput
      value={inputValue as Date | null}
      onChange={(val: Date | null) => setInputValue(val)}
      onKeyDown={onKeyDown}
      onBlur={onSave}
      valueFormat={valueFormat}
      clearable
      variant={variant}
      autoFocus={autoFocus}
      styles={{ input: { width: '140px' } }}
      aria-labelledby={ariaLabelledBy}
    />
  );
}
